import type { FC } from 'react';

import { Box, Grid, ErrorBoundary } from '@packages/shared';
import { ContentExternal } from '@packages/cms-components';
import type { CmsData } from '@packages/cms-components/interfaces';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { CategoryPageBrandOverviewFragmentFragmentDoc } from '@packages/gql/generated/shopping/CategoryPageBrandOverviewFragmentFragmentDoc';

import type { SearchSeoApiResponse } from '../../api/rest/types';
import { BrandList } from '../BrandList';
import { ProductListSeo } from '../ProductListSeo';

/* GraphQL */ `
  fragment CategoryPageBrandOverviewFragment on BrandsResult {
    brands {
      ...SearchBrandListFragment
    }
  }
`;

export type CategoryPageBrandOverviewProps = {
  cmsContent?: CmsData | null;
  seoResponse?: SearchSeoApiResponse | null;
  maskedResult: FragmentType<typeof CategoryPageBrandOverviewFragmentFragmentDoc>;
};

/**
 * Page content for Brands page
 * */
export const CategoryPageBrandOverview: FC<CategoryPageBrandOverviewProps> = ({
  cmsContent,
  seoResponse,
  maskedResult,
}) => {
  const { brands } = getFragmentData(CategoryPageBrandOverviewFragmentFragmentDoc, maskedResult);

  return (
    <Grid container spacing={0.5}>
      <Grid item>
        {cmsContent && (
          <ErrorBoundary>
            <ContentExternal data={cmsContent} />
          </ErrorBoundary>
        )}
        <Box
          sx={{
            padding: (theme) => theme.spacing(1),
          }}
        >
          <BrandList maskedBrands={brands} />
        </Box>

        {seoResponse && <ProductListSeo data={seoResponse} />}
      </Grid>
    </Grid>
  );
};
